import { userService } from './userService';
import { userinfo } from './userinfo';
import { restURL } from './../Models/restURL';
import { MotorProposal } from './../Models/MotorProposal';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProposalTrackingReq } from '../Models/ProposalTrackingReq';

@Injectable()
export class MotorproposalTrackingService {
    public trackingObj: ProposalTrackingReq = new ProposalTrackingReq();
    constructor(private http: HttpClient, private url: restURL, private userinfo: userService) { }

    public saveTrackStatus(proposalObj: MotorProposal): void {

        // this.http.post<ProposalTrackingReq>(this.url.baseURL + "/ProposalTracking/saveProposalStatus", proposalObj, this.userinfo.getHttpOptions()).toPromise().then((result) => {
        //     this.trackingObj = result;

        // }, (error) => {
        //     this.userinfo.checkTokenStatus(error);
        // });

    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/MotorproposalTrackingService.ts